const DESKTOP_MEDIA_QUERY = '(min-width: 1200px)';

export default () => {
  const header = document.getElementById('header');
  const stickyHeaderNav = document.getElementById('stickyHeaderNav');
  const topPageNav = document.querySelector('.site-nav--top-page');

  if (!header || !stickyHeaderNav || !topPageNav || !header.classList.contains('header--top-page')) {
    return;
  }

  if (header.dataset.topPageStickyHeaderInitialized === 'true') {
    return;
  }

  header.dataset.topPageStickyHeaderInitialized = 'true';

  const desktopMedia = window.matchMedia(DESKTOP_MEDIA_QUERY);
  let observer = null;
  let fallbackTicking = false;

  const setStickyState = (isSticky) => {
    header.classList.toggle('is-sticky-nav', isSticky);
    stickyHeaderNav.setAttribute('aria-hidden', String(!isSticky));
  };

  const getHeaderOffset = () => Math.ceil(header.getBoundingClientRect().height);

  const updateStickyStateFromRect = () => {
    const topPageNavRect = topPageNav.getBoundingClientRect();
    setStickyState(topPageNavRect.bottom <= getHeaderOffset());
  };

  const onFallbackScroll = () => {
    if (fallbackTicking) {
      return;
    }

    fallbackTicking = true;
    window.requestAnimationFrame(() => {
      updateStickyStateFromRect();
      fallbackTicking = false;
    });
  };

  const stopObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    window.removeEventListener('scroll', onFallbackScroll);
    setStickyState(false);
  };

  const startObserver = () => {
    stopObserver();

    if (!desktopMedia.matches) {
      return;
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        ([entry]) => {
          setStickyState(!entry.isIntersecting);
        },
        {
          rootMargin: `-${getHeaderOffset()}px 0px 0px 0px`,
          threshold: 0,
        },
      );

      observer.observe(topPageNav);
      return;
    }

    updateStickyStateFromRect();
    window.addEventListener('scroll', onFallbackScroll, { passive: true });
  };

  const handleViewportChange = () => {
    startObserver();
  };

  startObserver();
  window.addEventListener('resize', handleViewportChange);

  if (typeof desktopMedia.addEventListener === 'function') {
    desktopMedia.addEventListener('change', handleViewportChange);
  } else {
    desktopMedia.addListener(handleViewportChange);
  }
};
